var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighPriority = function SvgHighPriority(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4.667,
    x: 3,
    y: 12.334,
    fill: "#FD7F38",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 9.333,
    x: 8,
    y: 7.667,
    fill: "#FD7F38",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 14,
    x: 13,
    y: 3,
    fill: "#697477",
    fillOpacity: 0.4,
    rx: 1
  })));
};
export { SvgHighPriority as ReactComponent };
export default __webpack_public_path__ + "5b7eee0b9837e93a363eb4491a9e999f.svg";